import { useMemo, useState } from 'react'
import styled from 'styled-components'

import {
  CheckCurrencyProducts,
  checkCurrencyReatom,
} from '@root/features/premium/check-currency'
import { CheckCurrencyDialog } from '@root/features/premium/check-currency/ui/desktop'
import { PremiumInfoDialog } from '@root/features/premium/premium-information/ui/desktop'

import { PremiumPurchaseAds } from './premium-purchase-ads'
import { PremiumPurchaseSearch } from './premium-purchase-search'

export const PremiumPurchase: React.FC = () => {
  const [subscriptionInfoDrawerOpen, setSubscriptionInfoDrawerOpen] =
    useState(false)
  const [boosterInfoDrawerOpen, setBoostersInfoDrawerOpen] = useState(false)

  const model = useMemo(
    () => checkCurrencyReatom(undefined, { name: 'premiumScreen' }),
    [],
  )

  return (
    <Root>
      <PremiumPurchaseSearch model={model} />
      <PremiumPurchaseAds />
      <Footer>
        <CheckCurrencyProducts
          device="desktop"
          variant="vertical"
          onBoostersInfoClick={() => setBoostersInfoDrawerOpen(true)}
          onSubscriptionInfoClick={() => setSubscriptionInfoDrawerOpen(true)}
        />
      </Footer>
      <PremiumInfoDialog
        open={boosterInfoDrawerOpen}
        onOpenChange={setBoostersInfoDrawerOpen}
        product="boosters"
      />
      <PremiumInfoDialog
        open={subscriptionInfoDrawerOpen}
        onOpenChange={setSubscriptionInfoDrawerOpen}
        product="subscription"
      />

      <CheckCurrencyDialog model={model} />
    </Root>
  )
}

const Root = styled.div`
  min-height: 0;
  height: 100%;
  overflow: hidden;

  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  gap: 10px;
`

const Footer = styled.div`
  border: 1px solid var(--background-3);

  border-radius: 22px;
  padding: 6px;
`
